// extracted by mini-css-extract-plugin
module.exports = {"withButton":"Toast_withButton_2rUeB","errorMessage":"Toast_errorMessage_3mvMt"};